import React, { useContext, useEffect, useMemo, createContext, useReducer } from 'react'
import PropTypes from 'prop-types'
// import { consoleLog } from '../util'

// Initial State and Actions
const initialState = {
  theme: 'light',
  user: null,
  company: null,
  isAuthenticated: false,
  wordHighlighter: null
}

const actions = {
  SET_THEME: 'SET_THEME',
  SET_USER: 'SET_USER',
  SET_COMPANY: 'SET_COMPANY',
  SET_WORD_HIGHLIGHTER: 'SET_WORD_HIGHLIGHTER'
}

// Reducer to Handle Actions
const reducer = (state, action) => {
  switch (action.type) {
    case actions.SET_THEME: {
      localStorage.setItem('theme', action.theme)
      return {
        ...state,
        theme: action.theme,
        isLoading: false
      }
    }
    case actions.SET_USER: {
      return {
        ...state,
        user: action.user,
        isLoading: false,
        isAuthenticated: !!action?.user?.UserId
      }
    }
    case actions.SET_COMPANY: {
      return {
        ...state,
        company: action.company,
        isLoading: false,
        isAuthenticated: !!action?.company?.CompanyId
      }
    }
    case actions.SET_WORD_HIGHLIGHTER: {
      localStorage.setItem('wordHighlighter', JSON.stringify(action.wordHighlighter))
      return {
        ...state,
        wordHighlighter: action.wordHighlighter
      }
    }
    default:
      return state
  }
}

// Context and Provider
export const TodoListContext = createContext()

const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    const theme = localStorage.getItem('theme') || 'light'
    dispatch({ type: actions.SET_THEME, theme })

    const user = JSON.parse(localStorage.getItem('user'))
    dispatch({ type: actions.SET_USER, user })

    const company = JSON.parse(localStorage.getItem('company'))
    dispatch({ type: actions.SET_COMPANY, company })

    const wordHighlighter = JSON.parse(localStorage.getItem('wordHighlighter'))
    dispatch({ type: actions.SET_WORD_HIGHLIGHTER, wordHighlighter })
  }, [])

  const value = useMemo(() => ({
    theme: state.theme,
    user: state?.user || JSON.parse(localStorage.getItem('user')),
    company: state?.company || JSON.parse(localStorage.getItem('company')),
    isAuthenticated: state.isAuthenticated,
    wordHighlighter: state?.wordHighlighter || JSON.parse(localStorage.getItem('wordHighlighter')),

    setTheme: (theme) => {
      dispatch({ type: actions.SET_THEME, theme })
    },
    setUser: (user) => {
      dispatch({ type: actions.SET_USER, user })
    },
    setCompany: (company) => {
      dispatch({ type: actions.SET_COMPANY, company })
    },
    setWordHighlighter: (wordHighlighter) => {
      dispatch({ type: actions.SET_WORD_HIGHLIGHTER, wordHighlighter })
    }
  }), [state])

  return (
    <TodoListContext.Provider value={value}>
      {children}
    </TodoListContext.Provider>
  )
}

Provider.propTypes = {
  children: PropTypes.node
}

export default Provider

export const useGlobalStore = () => {
  const globalStore = useContext(TodoListContext)
  return globalStore
}
